// extracted by mini-css-extract-plugin
export var createdDate = "_o0-1";
export var divider = "_o0-2";
export var headerDivider = "_o0-3";
export var messagesCard = "_o0-0";
export var messagesContainer = "_o0-7";
export var messagesContainerWrapper = "_o0-4";
export var pointerCapturingButtonBoxes = "_o0-a";
export var showLeftPanelButton = "_o0-9";
export var showMoreButton = "_o0-c";
export var showMoreButtonContainer = "_o0-b";
export var summaryTitle = "_o0-6";
export var systemMessageCardWrapper = "_o0-d";
export var topButtons = "_o0-8";
export var withPadding = "_o0-5";